import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'
import { coordinates2d } from '../selectors/stompunkt'
import { currentLightStompunkt } from '../selectors/currentStompunkt'
import { fromSweref99TmToLatLng } from '../components/Leaflet/sweref99Tm'

const defaultView = {
    center: [61.5, 15],
    zoom: 3
}

export default createReducer(defaultView, {

    [actions.UPDATE_BOUNDS]: (state, action) => action.view,

    [actions.ZOOM_IN]: (state, action) => ({
    	center: state.center,
    	zoom: state.zoom + 1
    }),

    [actions.ZOOM_OUT]: (state, action) => ({
    	center: state.center,
    	zoom: state.zoom - 1
    }),

    [actions.ZOOM_TO_LAT_LNG]: (state, action) => ({
        center: action.coords,
        zoom: 12
    }),

    [actions.ZOOM_TO_CURRENT_STOMPUNKT]: (state, action, fullState) => ({
        center: fromSweref99TmToLatLng(coordinates2d(currentLightStompunkt(fullState))),
        zoom: 12
    })

})




// WEBPACK FOOTER //
// ./src/reducers/mapView.js